import React, { useState, useContext } from "react";
import { RootContext } from "../../RootContextProvider";
import { Button, message, Modal } from "antd";
import WelcomeStep1 from "./WelcomeStep1";
import WelcomeStep2 from "./WelcomeStep2";
import WelcomeStep3 from "./WelcomeStep3";
import WelcomeStep4 from "./WelcomeStep4";
import WelcomeStep5 from "./WelcomeStep5";
import "./Welcome.scss";
import ImageModal from "../../assets/visuals/banner-welcome-light-2.png";
import ImageSmallModal from "../../assets/visuals/small-banner-welcome.png";
import { createNewPageWelcome } from "../../utils/pages";
import { validateSocialLinks } from "../../utils/utils";

const Welcome = () => {
  const { user } = useContext(RootContext);
  const [modalOpen, setModalOpen] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [persona, setPersona] = useState("influenceur");
  const [pageName, setPageName] = useState();
  const [profilePicture, setProfilePicture] = useState();
  const [loading, setLoading] = useState(false);
  const [socials, setSocials] = useState();
  const [instagram, setInstagram] = useState({
    type: "instagram",
    display: true,
    url: "",
  });
  const [tiktok, setTiktok] = useState({
    type: "tiktok",
    display: true,
    url: "",
  });

  const handleSubmitSocials = async () => {
    console.log("validate socials welcome");
    setLoading(true);
    let socials = [instagram, tiktok];
    let socialsToSave = [];

    for (const social of socials) {
      if (social.display) {
        let isValid = await validateSocialLinks(social);
        if (!isValid.valid) {
          setLoading(false);
          message.error(isValid.error);
          return;
        } else {
          socialsToSave.push(social);
        }
      }
    }
    setSocials(socialsToSave);
    setCurrentStep(currentStep + 1);
    setLoading(false);
  };

  console.log(currentStep);
  const createPage = async () => {
    try {
      setLoading(true);
      console.log("create Page");
      if (pageName) {
        let data = {
          persona,
          pageName,
          socials,
          profilePicture: profilePicture ? profilePicture : null,
        };
        let res = await createNewPageWelcome(data);
        console.log(res);
        if (res.message !== "ok") {
          message.error("😅 Opsss, ce nom de page est déjà pris.");
          setCurrentStep(3);
        } else {
          localStorage.setItem("pageToLoad", res.data);
          window.location.replace("/links?status=pageCreated");
          //   setModalOpen(false);
        }
        setLoading(false);
      } else {
        message.error("Veuillez renseigner un nom de page valide");
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="welcome-container">
      <div className="new-page-title">
        <span role="img" aria-label="emoji">
          🏄‍♂️
        </span>{" "}
        Bienvenue sur Linksight {user.FirstName}
      </div>
      <Button
        onClick={() => {
          setModalOpen(true);
        }}
        type="primary"
        style={{ fontSize: "18px", height: "50px", marginTop: "35px" }}
      >
        Commencer dès maintenant
      </Button>
      <Modal
        footer={null}
        title=""
        visible={modalOpen}
        className="upgrade-modal welcome"
        closable={false}
        // onOk={handleOk}
        // onCancel={handleCancel}
        width={900}
      >
        <div className="modal-header-picture-welcome">
          <img
            src={
              currentStep === 0 || currentStep === 1
                ? ImageModal
                : ImageSmallModal
            }
            width="100%"
            alt="modal header"
          />
        </div>
        <div className="modal-upgrade-content">
          {currentStep === 1 ? (
            <WelcomeStep1 user={user} ImageModal={ImageModal} />
          ) : currentStep === 2 ? (
            <WelcomeStep2 persona={persona} setPersona={setPersona} />
          ) : currentStep === 3 ? (
            <WelcomeStep3 setPageName={setPageName} pageName={pageName} />
          ) : currentStep === 4 ? (
            <WelcomeStep4
              instagram={instagram}
              setInstagram={setInstagram}
              tiktok={tiktok}
              setTiktok={setTiktok}
            />
          ) : currentStep === 5 ? (
            <WelcomeStep5
              profilePicture={profilePicture}
              setProfilePicture={setProfilePicture}
            />
          ) : (
            ""
          )}
          <div className="company-description"></div>

          <div className="nagivation-builder">
            <Button
              className="submit-link-secondary"
              size="default"
              style={{ marginRight: "10px" }}
              disabled={currentStep === 1 ? true : false}
              onClick={() => setCurrentStep(currentStep - 1)}
            >
              Précédent
            </Button>
            {currentStep < 3 ? (
              <Button
                className="submit-link"
                size="default"
                onClick={() => setCurrentStep(currentStep + 1)}
                // disabled={campaignName ? false : true}
              >
                Suivant
              </Button>
            ) : currentStep === 3 ? (
              <Button
                className="submit-link"
                size="default"
                onClick={() => setCurrentStep(currentStep + 1)}
                disabled={pageName ? false : true}
              >
                Suivant
              </Button>
            ) : currentStep === 4 ? (
              <Button
                className="submit-link"
                size="default"
                onClick={() => handleSubmitSocials()}
              >
                Suivant
              </Button>
            ) : (
              <Button
                className="submit-link"
                size="default"
                onClick={() => {
                  createPage();
                }}
                loading={loading}
                disabled={socials && pageName ? false : true}
              >
                Créer ma page
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Welcome;
